import React, { Component } from "react";
import {
    Input,
} from "@material-ui/core";
import autoBind from "auto-bind";
import { debounce } from "lodash";

class SearchFloatingFilter extends Component {
    constructor(props) {
        super(props);

        autoBind(this);
    }

    handleSearch = debounce((val) => {
        this.props.onChange(val);
    }, 500)

    render() {

        return (
            <Input placeholder="Search.."
                onChange={(e) => {
                    const searchText = e.target.value;
                    this.handleSearch(searchText)
                }} />
        );
    }
}

export default SearchFloatingFilter;